import { FunctionComponent as F } from "react";
import Link from '@mui/material/Link';
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";


interface IProps
{
  rowKey?: string,
  linkId?: string,
  text: string,
  handleClick: () => void,
  colSpan: number
}

const LinkRow: F<IProps> = (props: IProps) =>
{
  return(
    <TableRow key={props.rowKey || ""}>
      <TableCell colSpan={props.colSpan} style={{ cursor: 'pointer' }} size={'small'}>
        <Link
          id={props.linkId || ""}
          variant='body2'
          underline='hover'
          onClick={props.handleClick} >
          <i>{props.text}</i>
        </Link>
      </TableCell>
    </TableRow>);
};

export default LinkRow;
